module.exports = [{"symbol":"$","name":"US Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"code":"USD","name_plural":"US dollars","active":false},{"symbol":"₱","name":"Philippine Peso","symbol_native":"₱","decimal_digits":2,"rounding":0,"code":"PHP","name_plural":"Philippine pesos","active":true}]


//////////////////
// WEBPACK FOOTER
// ./static/json/currency.json
// module id = E+Xt
// module chunks = 1